import * as React from "react";
import { hideModal } from "../../../../redux/reducers/ModalReducer";
import { SizedDropdownDataInput } from "../../dropdownDataInput/DropdownDataInput";
import { IAgreementWorksFromPackageJobRequest } from "../../../types/IAgreementWorksFromPackageJobRequest";
import { IAgreementWorksFromPackageJobResponse } from "../../../types/IAgreementWorksFromPackageJobResponse";

const DEFAULT_AGREEMENT_WORKS_FROM_PACKAGE_JOB_THRESHOLD = 1000;

export interface IAddWorksFromPackageViewProps {
    hideModal: typeof hideModal;
    getWorksFromPackage: (packageItems: any, dataSource: any) => void;
    createWorksFromPackageJob: (
        model: IAgreementWorksFromPackageJobRequest
    ) => Promise<IAgreementWorksFromPackageJobResponse>;
    textToScreen?: string;
    packageDetails?: any;
    dataSource?: string;
    agreementId?: number;
    agreementWorksFromPackageJobThreshold?: number;
}

interface IAddWorksFromPackageViewState {
    packageId?: string;
    errorString?: string;
}

export default class AddWorksFromPackageView extends React.PureComponent<IAddWorksFromPackageViewProps, IAddWorksFromPackageViewState> {
    constructor(props: IAddWorksFromPackageViewProps) {
        super(props);
        this.state = {
            packageId: null,
            errorString: null
        };
    }

    private getPackagesData = (): any[] => {
        const { packageDetails } = this.props;

        if (Array.isArray(packageDetails)) {
            return packageDetails;
        }

        if (Array.isArray(packageDetails?.data)) {
            return packageDetails.data;
        }

        return [];
    }

    private getSelectedPackage = () => {
        return this.getPackagesData().find(
            (pkg: any) => String(pkg.id) === String(this.state.packageId)
        );
    }

    handleAddWorksFromPackage = (value) => {
        this.setState({ packageId: value, errorString: null });
    }

    isLargePackage = () => {
        if (!this.state.packageId) {
            return false;
        }

        const selectedPackage = this.getSelectedPackage();

        const packageItems = selectedPackage?.packageItems;
        const packageItemCount = Array.isArray(packageItems) ? packageItems.length : 0;

        const threshold =
            this.props.agreementWorksFromPackageJobThreshold
            ?? DEFAULT_AGREEMENT_WORKS_FROM_PACKAGE_JOB_THRESHOLD;

        return packageItemCount > threshold;
    }

    handleSubmitAddWorksFromPackage = async () => {
        if (this.state.packageId === null || this.state.packageId === undefined || this.state.packageId === "") {
            this.setState({ errorString: "Package ID is required." });
            return;
        }

        const selectedPackage = this.getSelectedPackage();

        if (!selectedPackage) {
            this.setState({ errorString: "Selected package could not be found." });
            return;
        }

        if (this.isLargePackage()) {
            if (!this.props.agreementId) {
                this.setState({ errorString: "Agreement ID is required." });
                return;
            }

            await this.props.createWorksFromPackageJob({
                agreementId: this.props.agreementId,
                packageId: Number(this.state.packageId),
                dataSource: this.props.dataSource
            });

            return;
        }

        this.props.getWorksFromPackage(selectedPackage.packageItems, this.props.dataSource);
    }

    render() {
        return (
            <>
                <SizedDropdownDataInput
                    label={"Package ID"}
                    fieldName={"Package ID"}
                    value={this.state.packageId}
                    changeData={this.handleAddWorksFromPackage}
                    options={
                        this.getPackagesData()
                            .filter((pkg: any) => pkg.entityType === "Works")
                            .map((packageResult: any) => ({
                                code: packageResult.id,
                                description: `${packageResult.id}`,
                            }))
                    }
                    allowNull={true}
                    readOnly={false}
                    isHidden={false}
                    isMandatory={true}
                />

                <div className="flexWrapRow flexJustifyContentEnd paddingLarge" style={{ gap: "10%" }} >
                    <button className="button btn-defaultSecondary" style={{ maxWidth: "250px" }}
                        type="button"
                        onClick={this.props.hideModal}>
                        {"Cancel"}
                    </button>
                    <button className="button btn-defaultPrimary" style={{ maxWidth: "250px" }}
                        type="button"
                        onClick={this.handleSubmitAddWorksFromPackage}>
                        {"Add all works from Package"}
                    </button>
                </div>

                {this.isLargePackage() && (
                    <div className="paddingVeryLarge" style={{ color: "#605e5c", fontSize: "12px" }}>
                        <b>This is a large package. A background job will be started when you continue.</b>
                    </div>
                )}

                <div className="paddingVeryLarge" style={{ color: "#cd0303", fontSize: "12px" }}>
                    <b>{this.state.errorString}</b>
                </div>
            </>
        );
    }
}